<div class="container">
    <app-shell 
        style="width: 100%; height: 100%;"
    >
        <div class="lending-method stack">
            <div id="question">
                <h1>{{this.headerText}}</h1>
            </div>
            <!-- <div class="button-wrapper">
                <app-primary-button
                    [text]="'Confirm'" 
                    [clickEvent]="this.submit.bind(this)">
                </app-primary-button>
            </div>  -->
            <div class="details-view">
                <div  class="key-value-container" *ngFor="let item of displayData">
                    <span class="key-column">{{ item.key }}:</span>
                    <div class="value-edit">
                        <span class="value-column">{{ item.value }}</span>
                    </div>  
                </div>
            </div> 
        </div>
    </app-shell>
</div>   